import { useAppContext } from 'context/AppContext'
import { AuthContext, useAuth } from 'context/AuthContext'
import { createModal } from '../ModalFactory'
import { ModalWrapper } from '../ModalWrapper'
import Translation from 'components/Translation'
import resendVerification from 'services/cognito/resend-verification'
import { useEffect } from 'react'
import { useAppErrorApiContext } from 'context/AppErrorContext'
import { useRouter } from 'next/router'

const ModalProvider = createModal(
    AuthContext,
    'EmailVerificationModal',
    () => <span>Resend Email</span>,
    undefined,
    undefined
)

export const EmailVerificationModalCloser = ModalProvider.Closer

function EmailVerificationModal() {
    const ctx = useAuth()
    const { attributes } = ctx.EmailVerificationModal
    const { setGlobalError } = useAppErrorApiContext()
    const { setGlobalLoading } = useAppContext()
    const email = attributes?.email as string
    const router = useRouter()

    useEffect(() => {
        if (ctx.EmailVerificationModal.is_open) {
            window.history.replaceState(
                {
                    ...window.history.state,
                    as: '/verify-email',
                    url: '/verify-email',
                },
                '',
                '/verify-email'
            )
        }
    }, [ctx.EmailVerificationModal.is_open])

    const getModalCloser = () => (
        <div
            onClick={() => {
                ctx.EmailVerificationModal.close()
                ctx.SignupModal.close()

                ctx.ClientSignupModal.close()
                if (attributes?.redirect == 'client_login') {
                    ctx.ClientLoginModal.open()
                }
                // window.history.replaceState({}, '', './')
                router.push("/");
            }}
            className="absolute top-5 right-5"
        >
            <EmailVerificationModalCloser className="self-center" />
        </div>
    )

    const onResendEmail = async () => {
        try {
            setGlobalLoading(true)
            await resendVerification({ email })
        } catch (err) {
            setGlobalError(err.error)
        } finally {
            setGlobalLoading(false)
        }
    }

    return (
        <ModalProvider.Visible>
            <ModalWrapper className="w-wide p-3">
                <div
                    className="shadow-3xl rounded-lg mx-auto relative flex flex-col bg-white bg-cover bg-center w-full items-center
                    w-full sm:w-full lg:w-3/4
                    h-auto sm:h-4/5 lg:h-auto 2xl:h-auto 
                    m-auto relative flex p-0"
                >
                    {getModalCloser()}
                    <div>
                        <img
                            src="/images/verify_email.svg"
                            className="w-full rounded-lg"
                            alt="welcome"
                        />
                        <div
                            className="mt-10 flex justify-center text-3xl font-bold mb-7"
                            style={{ color: '#23476B' }}
                        >
                            <Translation content_key="verify_email"></Translation>
                        </div>
                        <div
                            className="flex justify-center mb-10 px-10 text-center"
                            style={{ color: '#23476B' }}
                        >
                            <Translation content_key="verify_email_desc" />
                            &nbsp;
                            {email}
                        </div>
                        <div
                            className="flex justify-center mb-10 text-sm"
                            style={{ color: '#A1A6AB' }}
                        >
                            <Translation content_key="verify_email_receive" />{' '}
                            &nbsp;
                            <p style={{ color: '#5E9FBD' }}>
                                <button onClick={onResendEmail}>
                                    <Translation
                                        content_key="resend_email"
                                        className=""
                                    />
                                </button>
                            </p>
                        </div>
                    </div>
                </div>
            </ModalWrapper>
        </ModalProvider.Visible>
    )
}

export default EmailVerificationModal
